import { com } from '@eidu/web'
import Option = com.eidu.sharedlib.form.definition.Option
import NextPage = com.eidu.sharedlib.form.definition.NextPage
import NextItem = com.eidu.sharedlib.form.definition.NextItem
import Next = com.eidu.sharedlib.form.definition.Next

export type LocalNextPage = {
  key: string
  type: 'page'
}

export type LocalNextItem = {
  key: string
  type: 'item'
}

export type LocalNext = LocalNextPage | LocalNextItem

const localNext = (option: Option): LocalNext | undefined => {
  if (option.next instanceof NextPage) {
    return { key: option.next.key, type: 'page' }
  } else if (option.next instanceof NextItem) {
    return { key: option.next.key, type: 'item' }
  } else {
    return undefined
  }
}

export const nextFromLocalNext = (localNext: LocalNext) => {
  if (localNext.type === 'page') {
    return new NextPage(localNext.key)
  } else if (localNext.type === 'item') {
    return new NextItem(localNext.key)
  }
}

export const localNextFromNext = (next: Next): LocalNext | undefined => {
  if (next instanceof NextPage) {
    return { key: next.key, type: 'page' }
  } else if (next instanceof NextItem) {
    return { key: next.key, type: 'item' }
  }
}

export default localNext
